import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

import { validateDraft } from '../../_shared/domain/user-draft.validation';

const selectEditUser = (state: RootState) => state.editUser;

export const selectUser = (state: RootState) => selectEditUser(state).user;
export const selectDraft = (state: RootState) => selectEditUser(state).draft;
export const selectLicenceName = (state: RootState) => selectEditUser(state).licenceName;
export const selectLoadStatus = (state: RootState) => selectEditUser(state).loadStatus;
export const selectSaveStatus = (state: RootState) => selectEditUser(state).saveStatus;
export const selectError = (state: RootState) => selectEditUser(state).error;
export const selectValidationErrors = (state: RootState) => selectEditUser(state).validationErrors;

export const selectIsSaving = (state: RootState) => selectEditUser(state).saveStatus === 'saving';
export const selectLoadFailed = (state: RootState) => selectEditUser(state).loadStatus === 'failed';

/** Derived: is the current draft valid? Memoised on the draft reference. */
export const selectIsDraftValid = createSelector(
  selectDraft,
  (draft) => Object.keys(validateDraft(draft)).length === 0,
);

/** Derived: why the LinkedIn URL is refused, if it is (#591). Memoised on the draft. */
export const selectLinkedInUrlError = createSelector(
  selectDraft,
  (draft) => validateDraft(draft).linkedinUrl,
);
